<script setup lang="ts">
import type { QRCode } from 'jsqr'

import BaseDialog from '~/components/molecules/BaseDialog.vue'
import QRCodeReader from '~/components/molecules/QRCodeReader.vue'

defineProps<{
  isActive: boolean
}>()

const emit = defineEmits<{
  (e: 'update:isActive', value: boolean): void
  (e: 'close'): void
}>()

const close = () => {
  emit('update:isActive', false)
  emit('close')
}

// Preview環境のURLを通すため
// 関連箇所：.github/workflows/develop-preview-on-pull-request-firebase-operator.yaml (channelId)
const host = location.host.replace(/--pr-\d+-[\w-]+/, '')
const regexp = new RegExp(`^${location.protocol}//${host}/(\\d+)/checkFiles/select/(\\d+)$`)

const handleDetected = async (code: QRCode) => {
  const match = code.data.match(regexp)
  if (match) {
    await navigateTo({
      name: 'organizationId-checkFiles-select-checkFileId',
      params: {
        organizationId: match[1],
        checkFileId: match[2],
      },
    })
    emit('update:isActive', false)
    emit('close')
  }
}
</script>

<template>
  <BaseDialog
    :is-active="isActive"
    :title="$t('二次元コード読み取り')"
    :padding="{ top: '0px', bottom: '0px', left: '0px', right: '0px' }"
    overflow-y="hidden"
    @close="close"
    @cancel="close"
  >
    <template #content>
      <div>
        <QRCodeReader :regexp="regexp" @detected="handleDetected" />
      </div>
    </template>
  </BaseDialog>
</template>
